export enum TagListDirectionMode {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}
